import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';

export function useUserPermissions() {
    const { hasAnyPermission, hasAnyPermissionForOrg, orgHasPermission, hasAllPermissions } = useActiveUserContext();

    const isDatasetOwner = hasAnyPermission([PermissionsEnum.OwnsSubmission]);
    //user?.orgMemberships?.some((om) => om.isDatasetOwner);
    //TODO PERMFE - redo with permissions+
    const isOrgOrVivliAdmin = hasAnyPermission([PermissionsEnum.DrActAdv, PermissionsEnum.ProviderActAdv]);
    //user?.isVivliAdmin || user?.orgMemberships?.some((om) => om.isOrgAdmin);
    const isDataProvider = isOrgOrVivliAdmin || hasAnyPermission([PermissionsEnum.DataContrib]);
    //user?.orgMemberships?.some((om) => om.isDataProvider);
    const isAnnotator = isDataProvider || hasAnyPermission([PermissionsEnum.CurateStudy]);

    const isHeadCurator = isAnnotator && hasAnyPermission([PermissionsEnum.ApproveCuration]);
    //user?.orgMemberships?.some((om) => om.isAnnotator);

    const isQaReviewer = isAnnotator || isHeadCurator || hasAnyPermission[PermissionsEnum.QaCuration];
    //user?.orgMemberships?.some((om) => om.isQaReviewer);

    const isIRPApprover = hasAnyPermission([PermissionsEnum.IRPApprove]);
    //user?.orgMemberships.some((om) => om.isIRPApprover);

    const studyPermissions = {
        canModifyPubliclyAvailable: (orgId: string) => {
            return isDataProviderForOrg(orgId) || isOrgAdmin(orgId) || hasAnyPermission([PermissionsEnum.DrActAdv]);
        }
    };

    const isOrgAdmin = (orgId: string) => {
        return orgHasPermission(orgId, PermissionsEnum.ProviderActAdv);
    };

    const isDataProviderForOrg = (orgId: string) => {
        return orgHasPermission(orgId, PermissionsEnum.DataContrib) && orgHasPermission(orgId, PermissionsEnum.ProviderActAdv);
        //return user?.orgMemberships?.some((om) => om.isOrgAdmin && om.isDataProvider && om.orgId === orgId);
    };
    const canUploadIpd = (organizationId: string) => {
        return isDataProviderForOrg(organizationId);
        //user.orgMemberships.some((org) => org.orgId === organizationId && (org.isOrgAdmin || org.isDataProvider));
    };

    const isOpsAdmin = hasAnyPermission(PermissionsEnum.UseAdmConsoleAdv);

    //isPresumedResearcher returns true if none of the other permissions exist. Does not validate user
    //involvement in any data requests (which is not the job of permissions checking)  but allows
    // a presumedResearcher access to an area (e.g. tab) that
    //will send a query to check for researcher involvement in data requests
    const isPresumedResearcher =
        !isOrgOrVivliAdmin && !isOpsAdmin && !isDataProvider && !isAnnotator && !isQaReviewer && !isHeadCurator && !isIRPApprover;

    return {
        canUploadIpd,
        isHeadCurator,
        isDatasetOwner,
        isOrgOrVivliAdmin,
        isDataProvider,
        isAnnotator,
        isQaReviewer,
        isIRPApprover,
        isDataProviderForOrg,
        isOrgAdmin,
        studyPermissions,
        isPresumedResearcher
    };
}
